// extracted by mini-css-extract-plugin
export default {"shell":"TopbarLayout_shell__IMoDS","body":"TopbarLayout_body__8DagL","main":"TopbarLayout_main__STPW6"};